<template>
  <v-autocomplete
    v-bind="bindStyle"
    :item-text="itemText"
    :item-value="itemValue"
    :value="value"
    dense
    :label="label"
    :placeholder="placeHolder"
    @input="emitValue"
    :items="items"
    hide-details
    prepend-inner-icon="mdi-filter-outline"
    class="general-selector">
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0">{{ item[itemText] }}</span>
      <!-- <span v-if="index === 1" class="grey--text text-caption ml-1">
        (+{{ value.length - 1 }})
      </span> -->
    </template>
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </v-autocomplete>
</template>

<script>
  import httpService from '@Utils/httpService';

  export default {
    props: {
      value: {
        type: String,
        default: () => null,
      },
      url: {
        type: String,
      },
      itemText: {
        type: String,
        default: 'name',
      },
      itemValue: {
        type: String,
        default: 'id',
      },
      defaultStyle: {
        type: Object,
        default: () => ({ solo: true, clearable: true }),
      },
      label: {
        type: String,
      },
      placeHolder: {
        type: String,
      },
      params: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      bindStyle() {
        return Object.assign({}, this.defaultStyle, this.$attrs);
      },
    },
    data() {
      return {
        items: [],
      };
    },
    methods: {
      emitValue(val) {
        this.$emit('input', val);
      },
    },
    mounted() {
      httpService
        .get({
          url: this.url,
          params: this.params,
        })
        .then((res) => {
          this.items = res.data.item || res.data || [];
        });
    },
  };
</script>

<style lang="scss">
  .general-selector {
    &.input-height-36 {
      .v-input__control {
        min-height: 36px !important;
      }
    }
    &.v-autocomplete.v-select input {
      min-width: 60px;
      width: 70px;
    }
    &.v-autocomplete.v-select.v-input--is-dirty input {
      min-width: 20px;
      width: 20px;
    }
  }
</style>
